import { gql } from 'apollo-angular'

/**
 * Minimal category information fragment Only includes the bare minimum. Array
 * is ordered by interal _order column
 */
export const CATEGORY_BASIC_FIELDS = gql`
  fragment CategoryBasicFields on Article_Categories {
    id
    title
    manual_page_number
    manual_preface
  }
`
